The page of webhook attempts and their corresponding cursors.
